var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"edit-newsletter-type"}},[_c('h2',[_vm._v("\n    Edit Newsletter Type '"),_c('router-link',{attrs:{"to":{
        name: 'newsletter_type',
        params: {
          'newsletterTypeId': _vm.newsletterTypeId
        }
      }}},[_vm._v(_vm._s(_vm.name))]),_vm._v("'\n  ")],1),_vm._v(" "),_c('newsletter-type-nav',{attrs:{"newsletterTypeId":_vm.newsletterTypeId}}),_vm._v(" "),_c('newsletter-type-form',{attrs:{"newsletterTypeId":_vm.newsletterTypeId}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-399b2946","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewsletterTypeEdit.vue
// module id = 1170
// module chunks = 1